import { useEffect } from "react";
import { createToast } from "shared/components/Spor";

export function useToastOnError(isError: boolean, onClose: () => void) {
  useEffect(() => {
    if (!isError) return;
    createToast({
      variant: "error",
      text: `Noe gikk galt ved innlasting av data`,
    });
    onClose();
  }, [isError]);
}
